module.exports = "/assets/data/68d5aab93c2f84463ec20e7165919cca-BS6.data.json";